import {Outlet} from "react-router-dom";

import {lazy} from "react";

// Public routes. Home is part of the main bundle, every other page is loaded on demand.
import Home from "../pages/home";
const AboutUs = lazy(() => import("../pages/about-us"));
const Login = lazy(() => import("../pages/login"));
const Checkout = lazy(() => import("../pages/checkout"));
const ContactUs = lazy(() => import("../pages/contact-us"));
const ForgotPassword = lazy(() => import("../pages/forgot-password"));
const Shop = lazy(() => import("../pages/shop"));
const ProductIndex = lazy(() => import("../pages/product"));
const Blog = lazy(() => import("../pages/blog"));
const Single = lazy(() => import("../pages/blog/details"));
const Solutions = lazy(() => import("../pages/solutions"));
const SolutionDetails = lazy(() => import("../pages/solutions/details"));
const B2B = lazy(() => import("../pages/b2b"));
const AppPrivacyAndPolicy = lazy(() => import("../pages/privacy-policy"));

const publicRoutes = [
    {path: "/", component: <Home/>, children: []},
    {path: "about-us", component: <AboutUs/>, children: []},
    {
        path: "blog", component: <Blog/>, children: [
            {path: ":id", component: <Single/>}
        ]
    },
    {path: "checkout", component: <Checkout/>, children: []},
    {path: "contact-us", component: <ContactUs/>, children: []},
    {path: "forgot-password", component: <ForgotPassword/>, children: []},
    {path: "login", component: <Login/>, children: []},
    {path: "shop", component: <Shop/>, children: []},
    {
        path: "product", component: <Outlet/>, children: [
            {path: ":slug", component: <ProductIndex/>},
        ]
    },
    {
        path: "solutions", component: <Solutions/>, children: [
            {path: ":slug", component: <SolutionDetails/>},
        ]
    },
    {path: "b2b", component: <B2B/>, children: []},
    {path: "mobile-app-privacy-policy", component: <AppPrivacyAndPolicy/>, children: []},
];

export {publicRoutes};